








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class ErrorGroup extends Vue {
  @Prop()
  protected okClicked?: boolean;
}
